import { Button } from "@mui/material";
import { useState } from "react";
import AddImageState from "./AddImageState";
import { useMutation, useQuery } from "react-query";
import { deleteFn, getFn, postFn } from "../../../Services/sharedGeneralFn";
import { API_URLS } from "../../../config/apiUrls";
import VariantImageCard from "./VariantImageCard";
import CustomModal from "../../../shared/CustomModal";
import { toast } from "react-toastify";

const SelectVariantImage = ({ open, handleClose, variantId }) => {
  const [state, setState] = useState(0);
  const [editImage, setEditImageId] = useState();
  const [selectedImage, setSelectedImage] = useState([]);

  const handleCloseFn = () => {
    handleClose();
    setSelectedImage([]);
  };

  const { data: imageData, refetch } = useQuery(
    ["multipleImageData"],
    () => getFn({ product_variant_id: variantId }, API_URLS.variantSelectImage),
    {
      enabled: open,
      select: (data) => data?.data?.data,
    }
  );

  const { mutate: deleteImage } = useMutation(
    (reqBody) => deleteFn(reqBody, API_URLS.multipleImageApi),
    {
      onSuccess: (res) => {
        if (res.data.response_code === 200) {
          toast.success(res.data.message);
          refetch();
        } else {
          toast.error(res.data.message);
        }
      },
    }
  );
  const { mutate: addSelectedImages } = useMutation(
    (reqBody) => postFn(reqBody, API_URLS.variantSelectImage),
    {
      onSuccess: (res) => {
        if (res.data.response_code === 200) {
          toast.success(res.data.message);
          handleCloseFn();
        } else {
          toast.error(res.data.message);
        }
      },
    }
  );

  const handleDelete = (id) => {
    deleteImage({
      product_variant_value: variantId,
      product_variant_image_ids: [id],
    });
  };

  return (
    <CustomModal
      title={
        "Select Variant Image"
        // state === 0 ? "Variant Image" : `${editImage ? "Update" : "Add"} Image`
      }
      open={open}
      onClose={handleCloseFn}
    >
      {/* {state === 0 ? ( */}
      <div>
        <div
          className={`flex p-2 gap-x-3 w-full h-[45vh] overflow-auto  ${
            !imageData ? "bg-white" : "bg-orange-100"
          }
            } bg-opacity-70 `}
        >
          <div className="grid relative grid-cols-4 py-4 gap-x-3 gap-y-3">
            {imageData?.map((item, idx) => (
              <VariantImageCard
                key={idx}
                item={item}
                selectedImage={selectedImage}
                setSelectedImage={setSelectedImage}
                setState={setState}
                imageData={imageData}
                setEditImageId={setEditImageId}
                handleDelete={handleDelete}
              />
            ))}
          </div>
          {!imageData && (
            <img
              src="https://img.freepik.com/free-vector/hand-drawn-no-data-concept_52683-127823.jpg"
              alt=""
              className="absolute !w-[94.7%]  h-[43.5vh] z-20"
            />
          )}
        </div>

        <div className="flex justify-between mt-1">
          <Button
            onClick={handleCloseFn}
            variant="contained"
            color="warning"
            className="!py-2 !mt-3"
          >
            CANCEL
          </Button>

          <Button
            onClick={() => {
              addSelectedImages({
                image_ids: selectedImage,
                product_variant_id: variantId,
              });
            }}
            variant="contained"
            color="success"
            className="!py-2 !mt-3"
          >
            +Add
          </Button>
        </div>
      </div>
      {/* ) : ( */}
      {/* <AddImageState
          editImageId={editImage}
          setEditImageId={setEditImageId}
          setState={setState}
          variantId={variantId}
        /> */}
      {/* )} */}
    </CustomModal>
  );
};

export default SelectVariantImage;
